import { createContext, useContext } from 'react'
import type { Scope } from './scope'

export const ScopeContext = createContext<Scope | undefined>(undefined)

/** The ambient scope, or `undefined` outside any `ScopeProvider`. */
export function useScope(): Scope | undefined {
  return useContext(ScopeContext)
}
